import { join, relative } from 'path';
import { createMonitor } from 'watch';
import { walkDir, rimraf, mkdirp } from 'xazure-builder-common';
import logger, { Levels } from 'xazure-logger';
import consoleLogger from 'xazure-logger-console';

console.log(process.cwd(), require.resolve('xazure-builder-common'));

export default async (dir, config, { source, dest, builders: builderConfigs },
                      watch = false, level = Levels.LOG) => {
  const builders = builderConfigs.map(({ builder, name, matcher }) =>
    ({ name, matcher, builder: builder(dir, config) }));

  logger.configure({ modules: [consoleLogger], level });

  const findBuilder = filePath => builders.find(({ matcher }) => matcher(filePath)) || {};

  const buildFile = filePath => {
    const { name, builder: { build } = {} } = findBuilder(filePath);
    console.log(findBuilder(filePath));

    if (!name) {
      logger.debug(`[skip] ${filePath}`);
    } else {
      logger.log(`${name ? `[${name}] ` : ''}${filePath}`);
      return Promise.resolve(build(filePath)).then(() => logger.debug(`[${name}] ${filePath} done.`));
    }
  };

  watch && createMonitor(join(dir, source), monitor => {
    monitor.on('created', filePath => {
      const relativePath = relative(join(dir, source), filePath);
      logger.debug('created', relativePath);
      buildFile(relativePath);
    });
    monitor.on('changed', filePath => {
      const relativePath = relative(join(dir, source), filePath);
      logger.debug('changed', relativePath);
      buildFile(relativePath);
    });
    monitor.on('removed', filePath => {
      const relativePath = relative(join(dir, source), filePath);
      const { builder: { remove = () => {} } = {} } = findBuilder(filePath);
      logger.debug('removed', relativePath);
      remove(relativePath);
    });
  });

  await rimraf(join(dir, dest));
  await mkdirp(join(dir, dest));
  return walkDir(join(dir, source), buildFile);
};